module.exports = __webpack_public_path__ + "static/media/students-group.e2e80830.png";